import React, { FC } from "react";
import { TestimonialProps } from "./ContentScreen";
import SectionTitle from "./SectionTitle";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import SwiperCore, { Navigation } from "swiper";

SwiperCore.use([Navigation]);

interface Testimonial {
  testimonials: TestimonialProps[];
}

const Testimonials: FC<Testimonial> = ({ testimonials }) => {
  return (
    <div
      id="testimonial"
      className="w-full md:min-h-screen flex flex-col items-center md:items-start justify-center md:px-20 py-10"
    >
      <SectionTitle highlight="Take a look at what" section="My clients Say" />
      <div className="w-full flex flex-col items-center justify-center mt-10">
        <div className="w-full lg:w-2/3 flex items-center justify-start overflow-hidden ">
          <Swiper navigation={true} className="mySwiper">
            {testimonials.map((testimonial, index) => {
              const imgUrl = getImage(testimonial.profileImage);
              return (
                <SwiperSlide key={index}>
                  <div className="min-w-full  lg:h-auto rounded-2xl border border-gray-400 flex flex-col items-center justify-center py-10">
                    <div className="w-48 h-48 rounded-full flex flex-col items-center justify-center bg-gray-300 overflow-hidden">
                      {imgUrl ? (
                        <GatsbyImage
                          image={imgUrl}
                          alt={testimonial.name}
                          className="w-48 h-48 rounded-full"
                        />
                      ) : (
                        <span className="text-6xl font-custom text-gray-500">
                          {testimonial.name.charAt(0).toUpperCase()}
                        </span>
                      )}
                    </div>
                    <p className="text-lg md:text-2xl w-2/3 text-center my-3 h-96 xl:h-40 xl:my-0 flex flex-col justify-center">
                      {testimonial.review.review}
                    </p>
                    <div className="flex items-center justify-around">
                      <h3 className="md:text-xl font-custom font-medium mx-3">
                        {testimonial.name.toUpperCase()}
                      </h3>
                      <span>|</span>
                      <h3 className="md:text-xl font-custom font-medium mx-3">
                        {testimonial.designation.toUpperCase()}
                      </h3>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
